/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
export const APP_NAME = "GoodVets";
export const GTM_ID = "GTM-K3N34DK";
export const DRAWER_WIDTH = 360;
export const WELLNESS_PLAN_URL = "https://www.good-vets.com/wellness-program";
export const TOTALCARE_URL = "https://www.goodvets.com/totalcare";
export const LOCATIONS_URL = "https://goodvets.com/locations";
export const VETCOVE_URL = "https://goodvets-nyc.sandbox.test.ourvet.com/pet";
export const ONLINE_PHARMACY_URL = "https://goodvets.com/services/online-pharmacy";
export const LOCALSTORAGE_KEY = "persistantState";
export const YEARS_PAST_PET = 30;
export const MAX_LOCATION_RANGE_IN_MILES = 50;
export const HOSPITAL_OPEN_KEY = "3b498fa83fc1";
export const DUPLICATE_ALERT_KEY = "duplcateAlertShown";
export const UPSELL_RENEWAL_ENTRY_POINT_KEY = "upsell_renewal_entry_point_key";
export const PLAN_CONFIRMATION_DISMISSED_KEY = "plan-confirmation-dismissed";
// Customer Referral
export const QUICK_SHARE_UPSELL = "quickshareUpsell";
export const REFERRAL_ADVOCATE_AMOUNT = "$100";
export const REFERRAL_REFEREE_AMOUNT = "$50";

export const LIST_GENDERS = [
  { value: "1", label: "Male" },
  { value: "3", label: "Female" },
];

export const MEDICAL_RECORDS_OPTIONS = [
  { value: "1", label: "Yes" },
  { value: "0", label: "No" },
];

export const NEUTERED_SPAYED_OPTIONS = [
  { value: "1", label: "Yes" },
  { value: "0", label: "No" },
];

export const MONTHS_NAME = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const SHORT_MONTHS_NAME = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const DRAWERS = {
  ADD_A_PET: "ADD_A_PET",
  BOOK_A_VISIT: "BOOK_A_VISIT",
  BOOK_NO_PETS: "BOOK_NO_PETS",
  PET_DETAIL: "PET_DETAIL",
  PET_MICROCHIP: "PET_MICROCHIP",
  PROFILE_EDIT: "PROFILE_EDIT",
  PROFILE_DETAIL: "PROFILE_DETAIL",
  PROFILE_DELETE: "PROFILE_DELETE",
  VISIT_DETAIL: "VISIT_DETAIL",
  VISIT_CONFIRMATION: "VISIT_CONFIRMATION",
  VISIT_RESCHEDULE_CONFIRMATION: "VISIT_RESCHEDULE_CONFIRMATION",
  VISIT_REASONS: "VISIT_REASONS",
  VISIT_SCHEDULE: "VISIT_SCHEDULE",
  VISIT_RESCHEDULE: "VISIT_RESCHEDULE",
  VISIT_PAYMENT_METHOD: "VISIT_PAYMENT_METHOD",
  UPDATE_MEDICAL_RECORDS: "UPDATE_MEDICAL_RECORDS",
  UPDATE_HOSPITAL_LOCATION: "UPDATE_HOSPITAL_LOCATION",
  UPDATE_HOSPITAL_APPOINTMENT: "UPDATE_HOSPITAL_APPOINTMENT",
  UPDATE_HOSPITAL_DETAIL: "UPDATE_HOSPITAL_DETAIL",
  UPDATE_HOSPITAL_CONFIRMATION: "UPDATE_HOSPITAL_CONFIRMATION",
  UPDATE_HOSPITAL_ERROR: "UPDATE_HOSPITAL_ERROR",
  UPDATE_HOSPITAL_WEB_USER: "UPDATE_HOSPITAL_WEB_USER",
  NOTIFICATIONS: "NOTIFICATIONS",
  PRESCRIPTION_DETAILS: "PRESCRIPTION_DETAILS",
};

export const PANEL_RIGHT = {
  VISIT_DETAIL: "VISIT_DETAIL",
};

export const SERVICE_STATUS_VALUES = {
  DROPOFF_VISIT_SERVICE: "dropoffAppointment",
  WELLNESS_PLAN_SERVICE: "wellnessPlanPurchase",
  INTEGRATED_FLOW_SERVICE: "integratedFlow",
  EXPRESS_VISIT_SERVICE: "vetTechAppointment",
  ONLINE_PHARMACY_SERVICE: "onlinePharmacyService",
};

export const MODALS = {
  MSA_CHANGE_MODAL: "MSA_CHANGE_MODALS",
  ADD_TO_CALENDAR: "ADD_TO_CALENDAR",
  LOGOUT: "LOGOUT",
  EDIT_LOCATION_ALERT: "EDIT_LOCATION_ALERT",
  ADD_ADDRESS: "ADD_ADDRESS_MODAL",
  BOOK_A_VISIT_NEW_USER: "BOOK_A_VISIT_NEW_USER",
  RESCHEDULE_A_VISIT: "RESCHEDULE_A_VISIT",
  RESCHEDULE_CONFIRMATION: "RESCHEDULE_CONFIRMATION",
  ADD_A_PET: "ADD_A_PET_MODAL",
  VISIT_CANCEL: "VISIT_CANCEL",
  USER_DELETE: "USER_DELETE",
  USER_DELETE_REDIRECT: "USER_DELETE_REDIRECT",
  UPDATE_HOSPITAL: "UPDATE_HOSPITAL",
  ADD_PAYMENT_METHOD: "ADD_PAYMENT_METHOD",
  APPOINTMENT_REVIEW: "APPOINTMENT_REVIEW",
  MANAGE_HOSPITAL_CHANGE: "MANAGE_HOSPITAL_CHANGE",
  UPDATE_HOSPITAL_PREVIEW: "UPDATE_HOSPITAL_PREVIEW",
  UPDATE_HOSPITAL_ERROR: "UPDATE_HOSPITAL_ERROR",
  AVAILABLE_TIME: "AVAILABLE_TIME",
  NEW_BOOK_A_VISIT: "NEW_BOOK_A_VISIT",
  CANCEL_BOOK_A_VISIT: "CANCEL_BOOK_A_VISIT",
  SELECT_PET_MODAL: "SELECT_PET_MODAL",
  CANCEL_PLAN_RENEWAL: "CANCEL_PLAN_RENEWAL",
  CANCEL_PLAN_RENEWAL_SUCCESS: "CANCEL_PLAN_RENEWAL_SUCCESS",
  CANCEL_UPCOMING_PLAN_RENEWAL: "CANCEL_UPCOMING_PLAN_RENEWAL",
  CANCEL_UPCOMING_PLAN_RENEWAL_SUCCESS: "CANCEL_UPCOMING_PLAN_RENEWAL_SUCCESS",
  CONTACT_HOSPITAL: "CONTACT_HOSPITAL",
  WELLNESS_PLAN_SELECT_PET: "WELLNESS_PLAN_SELECT_PET",
  PREQUAL_SELECT_PET: "PREQUAL_SELECT_PET",
  PREQUAL_INTERCEPTOR_MODAL: "PREQUAL_INTERCEPTOR_MODAL",
  WELLNESS_PLAN_PAYMENT_SUCCESS: "WELLNESS_PLAN_PAYMENT_SUCCESS",
  RATING_REVIEW_MODAL: "RATING_REVIEW_MODAL",
  VIEW_RATING_REVIEW_MODAL: "VIEW_RATING_REVIEW_MODAL",
  POST_TO_GOOGLE_MODAL: "POST_TO_GOOGLE_MODAL",
  CLOSE_PET_MODAL: "CLOSE_PET_MODAL",
  CLOSE_PET_CONFIRMATION: "CLOSE_PET_CONFIRMATION",
  UPDATE_PAYMENT_METHOD_MODAL: "UPDATE_PAYMENT_METHOD_MODAL",
  CALL_HOSPITAL_MODAL: "CALL_HOSPITAL_MODAL",
  OVERDUE_CONTACT_MODAL: "OVERDUE_CONTACT_MODAL",
  PENDING_INVOICE_ALERT_MODAL: "PENDING_INVOICE_ALERT_MODAL",
  PENDING_INVOICE_PAUSED_ALERT_MODAL: "PENDING_INVOICE_PAUSED_ALERT_MODAL",
  PENDING_INVOICE_CANCELLED_ALERT_MODAL: "PENDING_INVOICE_CANCELLED_ALERT_MODAL",
  GENERIC_PAYMENT_ISSUE_MODAL: "GENERIC_PAYMENT_ISSUE_MODAL",
  CONFIRM_DROP_OFF_MODAL: "CONFIRM_DROP_OFF_MODAL",
  RESCHEDULE_DROP_OFF_MODAL: "RESCHEDULE_DROP_OFF_MODAL",
  RESCHEDULE_URGENT_VISIT_MODAL: "RESCHEDULE_URGENT_VISIT_MODAL",
  ASSIGN_PAYMENT_MODAL: "ASSIGN_PAYMENT_MODAL",
  DUPLICATE_ACCOUNT_ALERT_MODAL: "DUPLICATE_ACCOUNT_ALERT_MODAL",
  UPDATE_PAYMENT_ERROR_MODAL: "UPDATE_PAYMENT_ERROR_MODAL",
  SELECTED_TIME_UNAVAILABLE: "SELECTED_TIME_UNAVAILABLE",
  EXPRESS_SERVICE_UPSELL_MODAL: "EXPRESS_SERVICE_UPSELL_MODAL",
  EXPRESS_VISIT_MODAL: "EXPRESS_VISIT_MODAL",
  EXPRESS_BOOKING_CONFIRMATION_MODAL: "EXPRESS_BOOKING_CONFIRMATION_MODAL",
  EXPRESS_VISIT_INFO_MODAL: "EXPRESS_VISIT_INFO_MODAL",
  CONFIRM_DOCTOR_VISIT_TOGGLE_MODAL: "CONFIRM_DOCTOR_VISIT_TOGGLE_MODAL",
  RESCHEDULE_EXPRESS_VISIT_MODAL: "RESCHEDULE_EXPRESS_VISIT_MODAL",
  EXPIRED_PAYMENT_UPDATE_MODAL: "EXPIRED_PAYMENT_UPDATE_MODAL",
  UPDATED_BOOK_A_VISIT_MODAL: "UPDATED_BOOK_A_VISIT_MODAL",
  UPDATED_BOOKING_CONFIRMATION_MODAL: "UPDATED_BOOKING_CONFIRMATION_MODAL",
  URGENT_CARE_TRANSITION_MODAL: "URGENT_CARE_TRANSITION_MODAL",
  URGENT_VISIT_MODAL: "URGENT_VISIT_MODAL",
  QUICK_SHARE_UPSELL_MODAL: "QUICK_SHARE_UPSELL_MODAL",
  INVITE_UPSELL_MODAL: "INVITE_UPSELL_MODAL",
  // wellness renewal alerts
  WELLNESS_PLAN_ENDED_ALERT: "WELLNESS_PLAN_ENDED_ALERT",
  WELLNESS_PLAN_RENEW_UNSUCCESSFUL_ALERT: "WELLNESS_PLAN_RENEW_UNSUCCESSFUL_ALERT",
  WELLNESS_PLAN_RENEWAL_SUCCESSFUL_ALERT: "WELLNESS_PLAN_RENEWAL_SUCCESSFUL_ALERT",
  WELLNESS_PLAN_RENEWAL_REMINDERS: "WELLNESS_PLAN_RENEWAL_REMINDERS",
  WELLNESS_PLAN_PAYMENT_ERROR_MODAL: "WELLNESS_PLAN_PAYMENT_ERROR_MODAL",
  // pet birthday form
  PET_BIRTHDAY_FORM_MODAL: "PET_BIRTHDAY_FORM_MODAL",
  // wellness plan renewal upsells (TotalCare transition)
  WELLNESS_RENEWAL_UPSELL: "WELLNESS_RENEWAL_UPSELL",
  WELLNESS_PLAN_TRANSITION_SUCCESS: "WELLNESS_PLAN_TRANSITION_SUCCESS",
  PAYMENT_INFORMATION_MODAL: "PAYMENT_INFORMATION_MODAL",
  SCRATCHPAY_INFO_MODAL: "SCRATCHPAY_INFO_MODAL",
  SCRATCHPAY_SUCCESS_MODAL: "SCRATCHPAY_SUCCESS_MODAL",
  SCRATCHPAY_RENEWAL_PENDING_MODAL: "SCRATCHPAY_RENEWAL_PENDING_MODAL",
  // other modals
  VETCOVE_REDIRECT_MODAL: "VETCOVE_REDIRECT_MODAL",
  GROUPED_APPOINTMENT_ACTION: "GROUPED_APPOINTMENT_ACTION",
  // customer support
  CUSTOMER_SUPPORT_MODAL: "CUSTOMER_SUPPORT_MODAL",
};

export const modalStorageKeys = {
  wellnessPlansEndingSoon: "modal_wellnessPlansEndingSoon",
  nonAutoRenewEndedPlans: "modal_nonAutoRenewEndedPlans",
  autoRenewEndedPlans: "modal_autoRenewEndedPlans",
  autoRenewSuccessPlans: "modal_autoRenewSuccessPlans",
  autoRenewUnsuccessfulEndedPlans: "modal_autoRenewUnsuccessfulEndedPlans",
} as const;

export type WellnessRenewalReminderType = (typeof modalStorageKeys)[keyof typeof modalStorageKeys];

export const WELLNESS_RENEWAL_ENTRY_POINTS = {
  RENEWAL_UPSELL_MODAL: "renewal_upsell_modal",
  REVIEW_NEW_PLANS_NOTIFICATION: "review_new_plans_notification",
  SCRATCHPAY_RENEWAL_APPLY_NOW_CLICKED: "scratchpay_renewal_apply_now_clicked",
  MANAGE_PLAN_RENEWAL_BANNER: "manage_plan_renewal_banner",
  DASHBOARD_RENEWAL_CARD: "dashboard_renewal_card",
  PLAN_AND_BILLING_RENEWAL_BANNER: "plan_and_billing_renewal_banner",
  WELLNESS_ALL_PLANS: "wellness_all_plans",
} as const;

export type WellnessRenewalEntryPoint =
  (typeof WELLNESS_RENEWAL_ENTRY_POINTS)[keyof typeof WELLNESS_RENEWAL_ENTRY_POINTS];

export const STEPPER_STEPS = {
  ADD_ADDRESS: ["Add Personal Details", "Choose a Location"],
  BOOK_A_VISIT: ["Select Pet", "Select Time", "Reason for  Visit"],
  NEW_USER_BOOK_A_VISIT: ["Select Time", "Add Pet", "Reason for  Visit"],
  APPOINMENT_RATING: ["Rating", "Recommendation", "Feedback 1", "Feedback 2"],
};

export const OVERDUE_STATUSES = {
  OVERDUE: "Overdue",
  PAUSED: "Paused",
  CANCELLED: "Cancelled",
} as const;

export const SCRATCHPAY_ACCOUNT_URL = "https://account.scratchpay.com/login";

export type OverdueStatus = (typeof OVERDUE_STATUSES)[keyof typeof OVERDUE_STATUSES];
// update with confirmed enums from backend
export const WELLNESS_PLAN_STATUSES = {
  ACTIVE: "active",
  PAUSED: "paused",
  LOCKED: "locked",
  CANCELLED: "cancelled",
} as const;

export type WellnessPlanStatus = (typeof WELLNESS_PLAN_STATUSES)[keyof typeof WELLNESS_PLAN_STATUSES];

export const CREATE_BOOKING_TYPE = {
  NORMAL_BOOKING: "normalBooking",
  DROPOFF_BOOKING: "dropoffBooking",
  EXPRESS_BOOKING: "expressBooking",
  URGENT_BOOKING: "urgentBooking",
} as const;

export type CreateBookingType = (typeof CREATE_BOOKING_TYPE)[keyof typeof CREATE_BOOKING_TYPE];

export const ASSIGNED_BOOKING_TYPE = {
  NORMAL_BOOKING: 1,
  DROPOFF_BOOKING: 2,
  EXPRESS_BOOKING: 4,
  URGENT_BOOKING: 5,
} as const;

export type AssignedBookingType = (typeof ASSIGNED_BOOKING_TYPE)[keyof typeof ASSIGNED_BOOKING_TYPE];

export const SOC_STATUSES = ["Current", "Almost Due", "Incomplete", "Overdue"];

// custom icon config for snackbar component
export const customIconsConfig = {
  DEFAULT: "default",
  SUCCESS_CELEBRATE_ICON: "successCelebrateIcon",
  NOTIFICATION_ALERT_ICON: "notificationAlertIcon",
  PAYMENT_UPDATE_ICON: "paymentUpdateIcon",
};

export const DEFAULT_RESOURCE_NAMES = {
  EXPRESS_VISIT: "Vet Technician",
};

export const SUBSCRIPTION_CARD_EXPIRY_STATUS = {
  EXPIRED: "Card Expired",
  EXPIRING_SOON: "Card Expires Soon",
  DISABLED: "Card Disabled",
  ISSUER_REPORT: "Card Issuer Alert",
};

export const EXPIRY_STATUS = {
  DISABLED: "disabled",
  EXPIRED: "expired",
  EXPIRING_SOON: "expiringsoon",
  ISSUER_REPORT: "issuerreport",
};
export const CARD_EXPIRY_STATUS = {
  EXPIRED: "Expired",
  EXPIRING_SOON: "Expires Soon",
  DISABLED: "Disabled",
  ISSUER_REPORT: "Issuer Alert",
};

export const REASON_CATEGORY = {
  WELLNESS: "Wellness",
  SICK: "Sick",
  EXPRESS: "Express",
};

export const EXPIRE_PAYMENT_ALERT_TYPES = {
  disabled: {
    label: "disabled",
    header: (petName: string) => "No payment method on file",
    // eslint-disable-next-line max-len
    body: (petName: string) =>
      `Your payment method for ${petName}'s subscription has been removed. To keep your subscription active and avoid disruption to care, please add a new card.`,
    cta: "Add Payment Method",
  },
  expired: {
    label: "expired",
    header: (petName: string) => `${petName}'s Wellness Plan Payment Method Is Expired`,
    // eslint-disable-next-line max-len
    body: (petName: string) =>
      `Update your payment method to keep ${petName}'s Wellness Plan active and to continue receiving benefits. Your plan is at risk of cancellation.`,
    cta: "Update Now",
  },
  expiringSoon: {
    label: "expiringSoon",
    header: (petName: string) => `${petName}'s Wellness Plan Payment Method Is Expiring Soon`,
    // eslint-disable-next-line max-len
    body: (petName: string) =>
      `Update your payment method to keep ${petName}'s Wellness Plan active and to continue receiving benefits. A delay may put your Wellness Plan at risk of cancellation.`,
    cta: "Update Now",
  },
  issuerReport: {
    label: "issuerReport",
    header: (petName: string) => `Payment Issue with ${petName}'s Wellness Plan`,
    // eslint-disable-next-line max-len
    body: (petName: string) =>
      `We received a notice from your card provider that your payment method for ${petName}'s subscription is no longer valid. Please update your card to avoid any interruptions in care.`,
    cta: "Update Now",
  },
};

export const ALERT_PAYMENT_PLAN_STATUS = {
  expiringSoon: {
    header: "The card expires soon",
    body: "The card expires soon. Select another payment option or add a new card.",
  },
  expired: {
    header: "The card has expired",
    body: "The card has expired. Select another payment option or add a new card.",
  },
  diabled: {
    header: "The card has been removed",
    body: "The card has been removed. Please select another payment option or add a new card.",
  },
  issuerReport: {
    header: "The card has a issuer alert",
    // eslint-disable-next-line max-len
    body: "We have been notified by your card provider that your payment method is no longer valid. Please update your card.",
  },
};

export type ExpirePaymentAlertType = "disabled" | "expired" | "expiringSoon" | "issuerReport";

export const APPOINTMENT_ERROR_CODE = {
  NORMAL_BOOKING_ERROR: "ea001",
  EXPRESS_BOOKING_ERROR: "ea002",
  URGENT_BOOKING_ERROR: "ea003",
};

export const BOOKING_FLOW_TYPE = {
  DEDICATED_EXPRESS_FLOW: "dedicatedExpressFlow",
  INTEGRATED_BOOKING_FLOW: "integratedBookingFlow",
};

export const URGENT_CARE_TRANSITION_SERVICES = [
  { label: "Walk-ins Welcome", value: "Walk-ins Welcome" },
  { label: "Sickness", value: "Sickness" },
  { label: "Injury", value: "Injury" },
  { label: "Other Concerns", value: "Other Concerns" },
];

export const wellnessSubCatgories = [
  "upcomingAutoRenewal",
  "upcomingPlanExpiration",
  "planExpiredNonRenewal",
  "paymentOverdueNotice",
  "planExpiredDueToNonPayment",
  "planRenewalSuccess",
  "renewalFailureDayOne",
  "renewalFailureDayTwo",
  "renewalFailureDayThree",
  "planExpiredAfterRenewalFailure",
];

// Purchse wellness plan subscription response status
export const PAYMENT_STATUS_RESPONSE = {
  SUCCESS: "Success",
  PENDING: "Pending",
  FAILED: "Failed",
};

export const PLAN_BILL_CYCLE_ID = {
  MONTHLY: 1,
  YEARLY: 2,
};

export const WELLNESS_PLAN_TYPES = {
  BASE: "base",
  PREMIUM: "premium",
  COMPREHENSIVE: "comprehensive",
  GOOD_PET_PLUS: "goodpetplus",
};

export const DEFAULT_PAGE_SIZE = 10;
